import type { JsonObject } from '@/app-package';
import type { TeamDoc } from '@bb/domain/dist/schemas';
import type { IGenericUser } from '@bb/users';
import axios from 'axios';

// @TODO: Move to `@/app-package`
export type ResultType = JsonObject<
  TeamDoc & {
    users: IGenericUser[];

    // missing fields
    _id: string;
    createdAt: string;
    updatedAt: string;
  }
>;

const get = async (teamId: string) => {
  const { data } = await axios.get<ResultType>(`/team/${teamId}`);
  return data;
};

export default get;
